import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "emotes" }
const _hoisted_2 = { class: "emotes__actions" }
const _hoisted_3 = { class: "emotes__grid" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "pill",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleInsert(' /e ')))
      }, "Start emote"),
      _createElementVNode("button", {
        type: "button",
        class: "pill",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleInsert(' ## ')))
      }, "End emote")
    ]),
    _withDirectives(_createElementVNode("input", {
      class: "emotes__search",
      type: "search",
      placeholder: "Search for emote ...",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.emoteFilter) = $event))
    }, null, 512), [
      [_vModelText, _ctx.emoteFilter]
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEmotes, (emote, index) => {
        return (_openBlock(), _createElementBlock("button", {
          key: index,
          class: "emotes__item",
          onClick: ($event: any) => (_ctx.handleInsert(' ' + emote + ' '))
        }, _toDisplayString(emote), 9, _hoisted_4))
      }), 128))
    ])
  ]))
}